<template>
  <footer id="contact" class="footer">
    <div class="container">
      <div class="footer__grid">
        <div v-for="col in footer.links" :key="col.title" class="footer__col">
          <h4 class="footer__col-title">{{ col.title }}</h4>
          <ul class="footer__list">
            <li v-for="item in col.items" :key="item" class="footer__item">
              <template v-if="item.includes(': ')">
                <span class="footer__label">{{ item.split(': ')[0] }}:</span>{{ item.split(': ')[1] }}
              </template>
              <a v-else class="footer__link" href="#" @click.prevent>{{ item }}</a>
            </li>
          </ul>
          <div v-if="col.title === '联系我们'" class="footer__qr">
            <img :src="footer.qrcode" alt="微信二维码" />
          </div>
        </div>
      </div>
      <div class="footer__bottom">
        <p>{{ footer.copyright }}</p>
        <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener">{{ footer.icp }}</a>
      </div>
    </div>
  </footer>
</template>

<script>
import { footer } from '@/assets/data/content'

export default {
  name: 'TheFooter',
  data() {
    return { footer }
  }
}
</script>
